import { combineEpics } from 'redux-observable';
import { loadDataSourceFlightFormatsEpicReducer } from '../ducks/DataSourceFlightFormats.ducks';
export default combineEpics(loadDataSourceFlightFormatsEpicReducer.epic);

//# sourceMappingURL=DataSourceFlightFormatsEpic.js.map
